export const copyToClipboard = (text: string): void => {
  void navigator.clipboard?.writeText(text).catch(() => undefined);
};
